import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Button from 'reactstrap/lib/Button';

import './change-button.scss';

const LABEL_NAME = 'Change style';

export function ChangeButton({ isSmall, tabIndex, year, makeName, modelName, styleId, columnName, toggleModal }) {
  const ymmName = `${year} ${makeName} ${modelName}`;

  function onClick() {
    toggleModal(styleId, columnName);
  }

  return (
    <Button
      color="link"
      onClick={onClick}
      className={classnames(
        'change-button popover-toggle text-transform-none text-primary-darker p-0 me-0_75 align-self-start mt-0_5',
        {
          'size-16': !isSmall,
          medium: isSmall,
        }
      )}
      tabIndex={tabIndex}
      aria-label={`${LABEL_NAME} for ${ymmName}`}
    >
      {LABEL_NAME}
    </Button>
  );
}

ChangeButton.propTypes = {
  toggleModal: PropTypes.func.isRequired,
  columnName: PropTypes.string.isRequired,
  styleId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  isSmall: PropTypes.bool,
  tabIndex: PropTypes.number,
  makeName: PropTypes.string,
  modelName: PropTypes.string,
  year: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

ChangeButton.defaultProps = {
  styleId: null,
  isSmall: false,
  tabIndex: 0,
  makeName: null,
  modelName: null,
  year: null,
};
